export default __webpack_public_path__ + "static/media/Screenshot (102).b39d1676.png";